import React from "react";
import { ReceiptOutline, LogOutOutline, SwapHorizontal, ArrowBackCircle } from 'react-ionicons'
import stylesWMS from "./stylesWMS"
import _post from "../Functions/NoBodyPost"
import constantURI from "../URI"
import { WMSDB } from "../ConstantURI"

export default class LandingPageOMS extends React.Component {

    constructor() {
        super();
        this.state = {
            In: "",
            Out: "",
            showAlertChange: false,
            module: 0
        }
    }

    async componentDidMount() {
        document.body.style.backgroundColor = "#e6e6fa";

        var username = JSON.parse(localStorage.getItem('Username'));
        var password = JSON.parse(localStorage.getItem('Password'));
        var token = JSON.parse(localStorage.getItem('Token'));
        const userType = JSON.parse(localStorage.getItem("UserType"));
        if (userType !== undefined && userType !== null) {
            await this.setState({ module: Number(userType), loading: false });
        }
        else {
            const db = WMSDB;
            const url = constantURI() + "Authentication?token=" + token+ "&user=" + username + "&username=" + username + "&password=" + password + "&db=" + db;
            await _post(url).then((response) => {
                return response.json().then(async (data) => {
                    if (data.result === undefined) {
                        this.setState({ alertUndefined: true });
                    }
                    else {
                        const typeUrl = constantURI() + "GetUserType?token=" + token+ "&user=" + username + "&username=" + username;
                        await _post(typeUrl).then((response) => {
                            return response.json().then(async (data) => {
                                if (data.result === undefined || data.result[0] === undefined || data.result[0].user_type_id[0] === undefined) {
                                    this.setState({ alertUndefined: true, loading: false });
                                }
                                else {
                                    if (data.result[0].user_type_id[0] === 2) {
                                        await this.setState({ module: 0, loading: false });
                                        await localStorage.setItem("UserType", JSON.stringify(0));
                                    }
                                    else if (data.result[0].user_type_id[0] === 4) {
                                        await this.setState({ module: 1, loading: false });
                                        await localStorage.setItem("UserType", JSON.stringify(1));
                                    }
                                    else if (data.result[0].user_type_id[0] === 6) {
                                        await this.setState({ module: 4, loading: false });
                                        await localStorage.setItem("UserType", JSON.stringify(4));
                                    }
                                }
                            })
                        })
                    }
                })
            })
        }
    }

    onClickTransfer = () => {
        if (this.state.module === 1) {
            localStorage.setItem("Interface", JSON.stringify(3));
        }
        else if (this.state.module === 4) {
            localStorage.setItem("Interface", JSON.stringify(2));
        }
        this.props.history.push("/Transfers")
    }

    onClickPick = () => {
        localStorage.setItem("Interface", JSON.stringify(1));
        this.props.history.push("/Requests")
    }

    render() {
        return (
            <div className="container-fluid vh-100" style={stylesWMS.mainContainer}>
                <div className="pt-3">
                    <ArrowBackCircle className="btn" onClick={() => this.props.history.push("./Modules")} color={'#00bfff'} height="50px" width="50px" />
                </div>
                {(this.state.module === 0) ?
                    <div>
                        <div className="row mt-3" >
                            <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => this.onClickPick()}>
                                <SwapHorizontal className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                <h4 className="card-text" style={stylesWMS.itemName}>Pick & Pack</h4>
                            </div>
                            <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => this.props.history.push("/")}>
                                <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                <h4 className="card-text" style={stylesWMS.itemName}>Logout</h4>
                            </div>
                        </div>
                    </div>
                    :
                    <div>
                        <div className="row" >
                            <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => this.onClickTransfer()}>
                                <ReceiptOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                <h4 className="card-text" style={stylesWMS.itemName}>Transfers</h4>
                            </div>
                            <div className="btn card col text-center pt-3 Box-Shadow m-2" style={stylesWMS.mainContainer} onClick={() => this.props.history.push("/")}>
                                <LogOutOutline className="row align-items-center justify-content-center" color={'#00bfff'} height="150px" width="150px" />
                                <h4 className="card-text" style={stylesWMS.itemName}>Logout</h4>
                            </div>
                        </div>
                    </div>
                }
            </div>
        );
    }
}
